import { useAuth } from '../context/AuthContext';

const modules = [
  {
    name: 'Pages',
    description: 'Create and publish CMS pages for the public website.',
  },
  {
    name: 'Sections',
    description: 'Structure each page with reusable, typed sections.',
  },
  {
    name: 'Content',
    description: 'Edit multilingual fields driven by the backend.',
  },
  {
    name: 'Media',
    description: 'Upload and attach images, video, and documents.',
  },
];

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <section className="border border-[#e4d9c8] bg-white px-6 py-7 sm:px-8">
        <div className="mb-4 h-px w-8 bg-[#8d7045]" />
        <p className="text-[12px] font-medium uppercase tracking-[0.16em] text-[#8d7045]">
          Dashboard
        </p>
        <h2 className="mt-2 font-[Merriweather] text-[1.5rem] text-[#130705] sm:text-[1.65rem]">
          Welcome back{user?.username ? `, ${user.username}` : ''}
        </h2>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-[#6b635c]">
          You are signed in to the CMS. Page, section, and media tools will be
          connected here in the next steps.
        </p>

        <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 border-t border-[#e4d9c8] pt-5 text-[13px]">
          <div>
            <span className="text-[#9a9288]">Status</span>
            <span className="ml-2 font-medium text-[#130705]">Authenticated</span>
          </div>
          <div>
            <span className="text-[#9a9288]">Role</span>
            <span className="ml-2 font-medium capitalize text-[#130705]">
              {user?.role || 'Admin'}
            </span>
          </div>
          <div>
            <span className="text-[#9a9288]">Languages</span>
            <span className="ml-2 font-medium text-[#130705]">EN · AR · KU</span>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <a
            href="/dashboard/global-layout"
            className="inline-flex rounded-md border border-[#e4d9c8] bg-white px-4 py-2 text-sm font-medium text-[#785E32] hover:bg-[#faf8f4]"
          >
            Edit navbar &amp; footer
          </a>
          <a
            href="/dashboard/pages"
            className="inline-flex rounded-md border border-[#e4d9c8] bg-white px-4 py-2 text-sm font-medium text-[#785E32] hover:bg-[#faf8f4]"
          >
            Edit pages
          </a>
        </div>
      </section>

      <section>
        <div className="mb-3 flex items-baseline justify-between gap-4">
          <h3 className="text-[13px] font-medium text-[#130705]">Modules</h3>
          <span className="text-[12px] text-[#9a9288]">Coming in next phase</span>
        </div>

        <ul className="grid gap-3 sm:grid-cols-2">
          {modules.map((module) => (
            <li
              key={module.name}
              className="border border-[#e4d9c8] bg-white px-5 py-5 transition hover:border-[#c9b48a]"
            >
              <div className="flex items-start justify-between gap-3">
                <p className="text-sm font-semibold text-[#130705]">
                  {module.name}
                </p>
                <span className="shrink-0 text-[11px] font-medium uppercase tracking-wide text-[#8d7045]">
                  Soon
                </span>
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-[#6b635c]">
                {module.description}
              </p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default DashboardPage;
